import Header from "../Components/header";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import useOrder from "../../hooks/useOrder";
import OrderCard from "../Components/order_card";
import { Skeleton } from "antd";
import Empty from "../Components/empty";
import Layout from "../../layout";

const ExpiredOrders = () => {
  const skeletonItems = [1, 1, 1, 1, 1, 1];
  const navigate = useNavigate();
  const { getExpiredOrders, expiredOrders, orderLoadings } = useOrder();

  useEffect(() => {
    getExpiredOrders();
  }, []);

  return (
    <Layout>
      <div>
        <Header
          title="سفارشات منقضی شده"
          backHandler={() => {
            navigate("/techapp");
          }}
        />
        <div className="tech-app-orders-container" style={{ marginTop: 60 }}>
          {/* list view */}
          {!orderLoadings?.getExpiredOrders &&
            expiredOrders?.length > 0 &&
            expiredOrders?.map((order, index) => {
              if (order?.status_id === 4) {
                return (
                  <OrderCard
                    order={order}
                    index={index}
                    type={order.status_name}
                    labelColor={"#fcc603"}
                  />
                );
              } else {
                return (
                  <OrderCard
                    order={order}
                    index={index}
                    type={order.status_name}
                    labelColor={"red"}
                  />
                );
              }
            })}
          {/* empty list */}
          {!orderLoadings?.getExpiredOrders && expiredOrders?.length === 0 && (
            <Empty title={"سفارشی یافت نشد."} />
          )}
          {/* skeleton loading */}
          {orderLoadings?.getExpiredOrders &&
            skeletonItems.map((item, index) => (
              <Skeleton.Button
                style={{
                  width: "100%",
                  height: "130px",
                  marginBottom: "10px",
                  borderRadius: "8px",
                }}
                shape={"square"}
                active
                key={index}
              />
            ))}
        </div>
      </div>
    </Layout>
  );
};
export default ExpiredOrders;
